export default __webpack_public_path__ + "static/media/doctor-demo.cfeb71af.png";